import React from 'react';
import { Box, Heading } from '@medely/ui-kit';
import { EditClockTimesFormContent } from './EditClockTimesFormContent';

export type EditClockTimesWebProps = {
  jobId: string;
} & React.PropsWithChildren;

export const EditClockTimes = ({ jobId, children }: EditClockTimesWebProps) => {
  return (
    <Box width="100%">
      {children}
      <Box mb={2}>
        <Heading size="m">Edit clock times</Heading>
      </Box>
      <EditClockTimesFormContent jobId={+jobId} />
    </Box>
  );
};
